import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import ReactToPrint from "react-to-print";

import { Translate, I18n } from "react-redux-i18n";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Report from "./Report";

import { setAlert } from "../../../actions/alertActions";
import { momentModule } from "../../utils/Utils";
import { manipulateInsights, groupDataBy } from "../manipulateInsights";

import "../../../styles/components/insights/reports/ReportsBy.scss";
import arrow from "../../../styles/images/arrow_black.svg";

const { moment, lastMonth, listMonths } = momentModule;

class ReportsBy extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.componentRef = null;

    this.state = {
      isLoading: false,
      toggles: new Array(6).fill(false),
      groupBy: null,
      data: null,
    };

    this.handleOnExport = this.handleOnExport.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchInsights(month, groupBy) {
    const monthDate = lastMonth(month);
    const startDate = monthDate.startOf("month").startOf("day").toDate();
    const endDate = monthDate.endOf("month").endOf("day").toDate();
    return axios.get("/api/private/reports", {
      cancelToken: new CancelToken((c) => (this.cancel = c)),
      params: { startDate, endDate, groupBy, type: this.props.mode },
    });
  }

  handleOnExport(month, groupBy) {
    this.safeSetState({ isLoading: true });
    return this.fetchInsights(
      month,
      this.props.mode === "evs" ? "by" + groupBy : groupBy
    )
      .then((res) => {
        if (res.status === 200) {
          const { data } = res;
          return new Promise((resolve) =>
            this.safeSetState(
              {
                data: {
                  ...data,
                  accountData: this.props.accountData,
                  brand: this.props.brand,
                },
                groupBy,
                month,
              },
              resolve
            )
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleToggle(idx) {
    this.safeSetState((prevState) => ({
      toggles: [
        ...prevState.toggles.slice(0, idx),
        !prevState.toggles[idx],
        ...prevState.toggles.slice(idx + 1),
      ],
    }));
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const startDate = moment()
      .utc()
      .subtract(6, "month")
      .startOf("month")
      .startOf("day");
    const endDate = moment()
      .utc()
      .subtract(1, "month")
      .endOf("month")
      .endOf("day");
    const months = listMonths(startDate, endDate).reverse();

    return (
      <div id="reportsBy" className="main-container">
        {months.map((m, idx) => (
          <Accordion key={m} className="highlight-container">
            <Accordion.Toggle
              as={Card.Header}
              onClick={() => this.handleToggle(idx)}
              eventKey={idx.toString()}
            >
              <span>
                <Translate value="reports_monthlyReport" />
                {` - ${m}`}
              </span>
              {this.props.mode === "evs" && this.props.isAdmin && (
                <button type="button" className="req-billing-btn">
                  {I18n.t("reports_billing_collection")}
                </button>
              )}
              <img
                src={arrow}
                alt=""
                className={this.state.toggles[idx] ? "arrow open" : "arrow"}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={idx.toString()}>
              <Card.Body>
                {this.props.mode === "evs" ? (
                  <div className="groups-container">
                    {/* <div className="group">
                      <Translate value="reports_groupByCard" />
                      <ReactToPrint
                        content={() => this.componentRef}
                        onBeforeGetContent={() => this.handleOnExport(m, "card")}
                        onBeforePrint={() => this.safeSetState({ isLoading: false })}
                        trigger={() => {
                          if (this.state.isLoading) return <Spinner animation="grow" />;
                          else
                            return (
                              <button type="button" className="link">
                                <Translate value="reports_export" />
                              </button>
                            );
                        }}
                      />
                    </div> */}
                    <div className="group">
                      <Translate value="reports_groupByUser" />
                      {this.state.isLoading ? (
                        <Spinner animation="grow" />
                      ) : (
                        <ReactToPrint
                          content={() => this.componentRef}
                          onBeforeGetContent={() =>
                            this.handleOnExport(m, "user")
                          }
                          onBeforePrint={() =>
                            this.safeSetState({ isLoading: false })
                          }
                          trigger={() => (
                            <button type="button" className="link">
                              <Translate value="reports_export" />
                            </button>
                          )}
                        />
                      )}
                    </div>
                    <div className="group">
                      <Translate value="reports_groupByEV" />
                      {this.state.isLoading ? (
                        <Spinner animation="grow" />
                      ) : (
                        <ReactToPrint
                          content={() => this.componentRef}
                          onBeforeGetContent={() =>
                            this.handleOnExport(m, "ev")
                          }
                          onBeforePrint={() =>
                            this.safeSetState({ isLoading: false })
                          }
                          trigger={() => (
                            <button type="button" className="link">
                              <Translate value="reports_export" />
                            </button>
                          )}
                        />
                      )}
                    </div>
                    <div className="group">
                      <Translate value="reports_groupByFleet" />
                      <ReactToPrint
                        content={() => this.componentRef}
                        onBeforeGetContent={() =>
                          this.handleOnExport(m, "fleet")
                        }
                        onBeforePrint={() =>
                          this.safeSetState({ isLoading: false })
                        }
                        trigger={() => {
                          if (this.state.isLoading)
                            return <Spinner animation="grow" />;
                          else
                            return (
                              <button type="button" className="link">
                                <Translate value="reports_export" />
                              </button>
                            );
                        }}
                      />
                    </div>
                    <div className="group">
                      <Translate value="reports_groupByNetwork" />
                      {this.state.isLoading ? (
                        <Spinner animation="grow" />
                      ) : (
                        <ReactToPrint
                          content={() => this.componentRef}
                          onBeforeGetContent={() =>
                            this.handleOnExport(m, "network")
                          }
                          onBeforePrint={() =>
                            this.safeSetState({ isLoading: false })
                          }
                          trigger={() => (
                            <button type="button" className="link">
                              <Translate value="reports_export" />
                            </button>
                          )}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="groups-container">
                    <div className="group">
                      <Translate value="reports_groupByChargers" />
                      <ReactToPrint
                        content={() => this.componentRef}
                        onBeforeGetContent={() =>
                          this.handleOnExport(m, "charger")
                        }
                        onBeforePrint={() =>
                          this.safeSetState({ isLoading: false })
                        }
                        trigger={() => {
                          if (this.state.isLoading)
                            return <Spinner animation="grow" />;
                          else
                            return (
                              <button type="button" className="link">
                                <Translate value="reports_export" />
                              </button>
                            );
                        }}
                      />
                    </div>
                    <div className="group">
                      <Translate value="reports_groupByChargingArea" />
                      {this.state.isLoading ? (
                        <Spinner animation="grow" />
                      ) : (
                        <ReactToPrint
                          content={() => this.componentRef}
                          onBeforeGetContent={() =>
                            this.handleOnExport(m, "infrastructure")
                          }
                          onBeforePrint={() =>
                            this.safeSetState({ isLoading: false })
                          }
                          trigger={() => (
                            <button type="button" className="link">
                              <Translate value="reports_export" />
                            </button>
                          )}
                        />
                      )}
                    </div>
                    <div className="group">
                      <Translate value="reports_groupByUser" />
                      {this.state.isLoading ? (
                        <Spinner animation="grow" />
                      ) : (
                        <ReactToPrint
                          content={() => this.componentRef}
                          onBeforeGetContent={() =>
                            this.handleOnExport(m, "user")
                          }
                          onBeforePrint={() =>
                            this.safeSetState({ isLoading: false })
                          }
                          trigger={() => (
                            <button type="button" className="link">
                              <Translate value="reports_export" />
                            </button>
                          )}
                        />
                      )}
                    </div>
                  </div>
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        ))}
        <div style={{ display: "none" }}>
          <Report
            groupBy={this.state.groupBy}
            month={this.state.month}
            data={this.state.data}
            mode={this.props.mode}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  isAdmin: state.account.isAdmin,
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(ReportsBy);
